import { render, staticRenderFns } from "./OpmessageTable.vue?vue&type=template&id=74006d98&scoped=true&"
import script from "./OpmessageTable.vue?vue&type=script&lang=js&"
export * from "./OpmessageTable.vue?vue&type=script&lang=js&"
import style0 from "./OpmessageTable.vue?vue&type=style&index=0&id=74006d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74006d98",
  null
  
)

export default component.exports